import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { AssetSearchFilterElementDto } from '@/api';
import SIcon from '@/components/SIcon.vue';
import SEllipsisTooltip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Asset-Type-Icon',
  props: {
  value: null
},
  emits: ["input"],
  setup(__props) {


const { value: facet } = __MACROS_useVModel(["value", undefined, "input"]);

const name = _computed(() => facet.value.name || '');
const icon = _computed(() => {
  switch (facet.value.icon) {
    case AssetSearchFilterElementDto.icon.TABLE_AND_VIEW:
      return 'icon-data-table';
    case AssetSearchFilterElementDto.icon.DASHBOARD:
      return 'icon-chart-multiple';
    case AssetSearchFilterElementDto.icon.PIPELINE:
      return 'icon-pipeline-orchestrator';
    case AssetSearchFilterElementDto.icon.ML_MODEL:
      return 'icon-brain-circuit';
    case AssetSearchFilterElementDto.icon.GENERIC:
      return 'icon-grid';
    default:
      return AssetSearchFilterElementDto.icon.GENERIC;
  }
});


return { __sfc: true,facet, name, icon, _computed, __MACROS_useVModel, AssetSearchFilterElementDto, SIcon, SEllipsisTooltip }
}

})